import Faqs from "../components/Faqs";
import InnerBanner from "../presentation/InnerBanner";
import SEO from "../global/SEO";

const Faq = () => (
  <>
    <SEO 
      title="Assignment Tips, Study Hacks & Academic Guides | LiveAssignment Blog"
      description="Explore expert tips, study strategies, and academic writing guides to boost your grades. New content weekly from top educators."
      keywords="assignment tips, study guides, academic writing tips, homework help, study strategies, educational resources, academic success tips, assignment writing guides"
      h1Heading="LiveAssignment Blog – Your Go-To Academic Resource Hub"
      canonicalUrl="https://liveassignment.com/faq"
    />
    <InnerBanner pageTitle="FAQ's"></InnerBanner>
    <Faqs />
  </>
);

export default Faq;
